import { getLargeThemeImageUrl } from 'bookwithme-shared';

export function defaultBanner(): string {
    return getLargeThemeImageUrl(9);
}
